<template>
  <div>
    <el-dialog title="过磅" :visible.sync="weighVisible" :close-on-click-modal="false" width="85%" center
      :before-close="closeadd">
      <div class="topForm">
        <div>
          <div style="margin:20px 30px 20px 10px;">称重类型：</div>
          <div style="width:100px;">
            <el-radio-group v-model="weightType">
              <el-radio :label="1" style="margin:10px 30px 20px 20px;" :disabled='weightTypeDisabled'>毛重</el-radio>
              <el-radio :label="2" style="margin:0 30px 20px 20px;">皮重</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div style="margin:0 20px 20px 50px;text-align: center;">
          <div style="margin:20px 30px 20px 0;font-weight: 700;">本次称重</div>
          <div class="weigthBox">
            <span>{{poundWeight}}</span>
          </div>
          <div style="margin-top:10px;">
            <div>如有故障，请<span style="color:blue;">手动输入</span></div>
          </div>
          <div style="margin-top:10px;">
            <el-input v-model="wieghtInput" placeholder="请输入重量" size="mini" v-number-input.float="4" maxlength="50"
              style="width:130px;"></el-input> 吨
          </div>
        </div>
        <!-- <div style="margin:0 30px 20px 50px;text-align: center;" v-if="weightType == 2">
        <div style="margin:30px 30px 20px 0;font-weight: 700;">净重</div>
        <div class="weigthBoxB">
          <span>13.999</span>
        </div>
      </div> -->
      </div>
      <div class="bottomTable">
        <div class="detailsTitle">
          <h4>货物信息</h4>
          <el-button style="position:absolute;left:110px;" type="primary" @click="refreshClick">刷新</el-button>
          <el-button style="position:absolute;left:170px;" type="primary" @click="getLatestInTareWeightInfoClick"
            :disabled="TwoIsDisable">同步上次毛重</el-button>
          <div style="position:absolute;left:305px;display:flex;">
            <el-button type="primary" @click="clearWeightingWeight">清空毛重</el-button>
            <div style="margin:5px 0 0 10px;">{{GBoutstockPlateNumber}}</div>
          </div>
        </div>
        <el-table min-height="300px" max-height="350px" size="mini" border center bordersize="mini" ref="tableList"
          :data="tableList" style="width: 100%" highlight-current-row @row-click="dianjixuanzhong"
          :row-class-name="tableRowClassName" class="elTab">
          <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
          <el-table-column prop="steelMillName" label="产地" align="center"></el-table-column>
          <el-table-column prop="specification" label="规格" align="center" width="130"></el-table-column>
          <el-table-column prop="model" label="材质" align="center" width="130"></el-table-column>
          <el-table-column prop="number" label="件数" align="center"></el-table-column>
          <el-table-column prop="grossWeight" label="毛重(吨)" align="center"></el-table-column>
          <el-table-column prop="grossWeightTime" label="毛重时间" align="center" width="180" :formatter="dateTimeFormat">
          </el-table-column>
          <el-table-column prop="tareWeight" label="皮重(吨)" align="center"></el-table-column>
          <el-table-column prop="tareWeightTime" label="皮重时间" align="center" width="180" :formatter="dateTimeFormat">
          </el-table-column>
          <el-table-column prop="weightingWeight" label="净重(吨)" align="center"></el-table-column>
          <el-table-column prop="estimatedSingletonWeight" label="预报实入件重(吨)" align="center" width="130">
          </el-table-column>
          <!-- <el-table-column prop="forecastSingletonWeight" label="预报件重" align="center" ></el-table-column> -->
          <el-table-column prop="warehouseName" label="仓位" align="center"></el-table-column>
          <el-table-column prop="vehicleNumber" label="船号" align="center"></el-table-column>
          <el-table-column prop="shipForecastNo" label="预报编号" align="center" width="300"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" style="width: 220px; margin: 15px auto">
        <el-button @click="closeadd">取 消</el-button>
        <el-button type="primary" :loading="Loading" @click="addDialog" :disabled='addDisabled'>保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    calculateOutStockWeight, // 刷新调接口
    getPoundWeight,
    getLatestOutGrossWeightInfo,
    clearSpecifiedWeightInfo
  } from '@/api/wms-access'
  import {
    getEmptyWeightInfoListForOutstockId,
    updateEmptyWeightInfoList // 过磅保存
  } from '@/api/wms-stock'
  import {
    dateTimeFormat
  } from '@/utils/util.js'
  import DonMessage from '@/utils/message'
  export default {
    name: 'xieCheDialog',
    data() {
      return {
        dateTimeFormat: dateTimeFormat,
        tableList: [],
        Loading: false,
        weightType: 0,
        wieghtInput: '',
        xuanzhongArr: null,
        addDisabled: true,
        weightTypeDisabled: false,
        flagA: true,
        poundWeight: 0,
        _inter: null,
        allWeight: '',
        TwoIsDisable: false
      }
    },
    props: {
      weighVisible: {
        type: Boolean,
        default: false
      },
      outstockId: {
        type: Number
      },
      GBoutstockPlateNumber: {
        type: String
      }
    },
    watch: {},
    created() {
      this.getInWeightInfoList()
      this.interval()
      var _this = this
      document.onkeydown = function (e) {
        let key = window.event.keyCode
        if (key == 13) {}
      }
      // console.log(this.GBoutstockPlateNumber)
    },
    methods: {
      interval() {
        this._inter = setInterval(() => {
          this.getPoundWeight()
        }, 1000)
      },
      getPoundWeight() {
        getPoundWeight()
          .then(res => {
            this.poundWeight = res
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      },
      timeStamp2: function (value) { // 具体到时分秒
        var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var year = date.getFullYear()
        var month = ('0' + (date.getMonth() + 1)).slice(-2)
        var sdate = ('0' + date.getDate()).slice(-2)
        var hour = ('0' + date.getHours()).slice(-2)
        var minute = ('0' + date.getMinutes()).slice(-2)
        var second = ('0' + date.getSeconds()).slice(-2)
        // 拼接
        var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
        // 返回
        return result
      },
      getInWeightInfoList() {
        getEmptyWeightInfoListForOutstockId({
            outstockId: this.outstockId
          })
          .then(res => {
            if (res.length != 0) {
              this.tableList = res
              // 判断是否有皮重，没有皮重显示皮重，有皮重显示毛重
              if (this.tableList[0].tareWeight) {
                this.weightType = 1
                this.weightTypeDisabled = false
                this.flagA = true
              } else {
                this.weightType = 2
                this.weightTypeDisabled = true
                this.flagA = false
              }
            }
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      },
      closeDialogFile() {
        this.Loading = false
      },
      closeadd() {
        this.$emit('update:weighVisible', false)
        clearInterval(this._inter)
      },
      addDialog(params) {
        this.shipStockWeight(this.tableList)
      },
      shipStockWeight(params) {
        updateEmptyWeightInfoList(params).then(res => {
            DonMessage.success('保存成功')
            this.wieghtInput = ''
            this.closeadd()
            this.$parent.chaxun()
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        this.$set(row, 'index', rowIndex)
        // row.index = rowIndex
      },
      dianjixuanzhong(row) {
        this.xuanzhongArr = {}
        this.xuanzhongArr = row
      },
      // 点击刷新
      async refreshClick() {
        let weightFlag = ''
        if (this.weightType == '1') {
          weightFlag = '毛重'
          if (this.wieghtInput == '' && this.poundWeight == '0') {
            DonMessage.error('请填写重量')
          } else if (this.xuanzhongArr != null) {
            if (this.wieghtInput != '' && this.poundWeight != '0') {
              this.allWeight = this.wieghtInput
            } else if (this.wieghtInput != '' && this.poundWeight == '0') {
              this.allWeight = this.wieghtInput
            } else if (this.poundWeight != '0') {
              this.allWeight = this.poundWeight
            }
            let params = {
              index: this.xuanzhongArr.index, // 索引,
              weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
              weightFlag: weightFlag, // 毛重或皮重的标识，
              operator: localStorage.getItem('userName'), // 操作人，
              list: this.tableList // 过磅页面回显的list数据
            }
            let res = await calculateOutStockWeight(params)
            this.tableList = JSON.parse(JSON.stringify(res.list))
            this.addDisabled = false
            if (this.weightType == '1') {
              console.log(this.tableList[this.xuanzhongArr.index], 'this.xuanzhongArr')
              let arr = this.tableList[this.xuanzhongArr.index]

              // 任务8420 修改提示信息
              if (this.tableList[this.xuanzhongArr.index].checkFlag == '1') {
                // 提示：规格**过磅净重**吨，超过预报件重**吨的千分之三
                // isForecastActualSingletonWeight 1 有预报   0 无预报
                if (this.tableList[this.xuanzhongArr.index].isForecastActualSingletonWeight == '1') {
                  this.$confirm('过磅平均件重' + arr.weighSingletonWeight + '吨' + '超过预报实入件重' + arr
                    .estimatedSingletonWeight + '吨' + '的千分之三，是否继续？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                    this.shipStockWeight(this.tableList)
                  }).catch(() => {})
                } else {
                  this.$confirm('过磅平均件重' + arr.weighSingletonWeight + '吨' + '超过库存件重' + arr.estimatedSingletonWeight +
                    '吨' + '的千分之三，是否继续？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                    this.shipStockWeight(this.tableList)
                  }).catch(() => {})
                }
              }
            }
            this.xuanzhongArr = null
          } else {
            DonMessage.error('请先选择一条数据')
          }
        } else {
          weightFlag = '皮重'
          if (this.wieghtInput == '' && this.poundWeight == '0') {
            DonMessage.error('请填写重量')
          } else {
            if (this.wieghtInput != '' && this.poundWeight != '0') {
              this.allWeight = this.wieghtInput
            } else if (this.wieghtInput != '' && this.poundWeight == '0') {
              this.allWeight = this.wieghtInput
            } else if (this.poundWeight != '0') {
              this.allWeight = this.poundWeight
            }
            if (this.flagA) {
              console.log(this.xuanzhongArr, 'this.xuanzhongArr')
              if (this.xuanzhongArr == null) {
                DonMessage.error('请先选择一条数据')
              } else {
                let params = {
                  index: this.xuanzhongArr.index, // 索引,
                  weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
                  weightFlag: weightFlag, // 毛重或皮重的标识，
                  operator: localStorage.getItem('userName'), // 操作人，
                  list: this.tableList // 过磅页面回显的list数据
                }
                let res = await calculateOutStockWeight(params)
                this.tableList = JSON.parse(JSON.stringify(res.list))
                this.addDisabled = false
                this.xuanzhongArr = null
              }
            } else {
              calculateOutStockWeight({
                  // index: this.xuanzhongArr.index, // 索引,
                  weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
                  weightFlag: weightFlag, // 毛重或皮重的标识，
                  operator: localStorage.getItem('userName'), // 操作人，
                  list: this.tableList // 过磅页面回显的list数据
                }).then(res => {
                  this.tableList = res.list
                  this.addDisabled = false
                })
                .catch(err => {
                  DonMessage.error(err.message)
                })
            }
          }
        }
      },
      // 点击同步皮重
      getLatestInTareWeightInfoClick() {
        if (this.flagA) {
          DonMessage.error('已过皮重，不能同步')
        } else {
          getLatestOutGrossWeightInfo({
              outstockPlateNumber: this.GBoutstockPlateNumber // 出库车牌号
            }).then(res => {
              // 获取到的毛重和毛重时间，更新现在的皮重和皮重时间
              // tareWeight 皮重  tareWeightTime 皮重时间 grossWeight 毛重 grossWeightTime毛重时间
              this.$confirm('已查询到上次毛重数据，是否同步？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.tableList.forEach(item => {
                  this.$set(item, 'tareWeight', res.grossWeight)
                  this.$set(item, 'tareWeightTime', res.grossWeightTime)
                  this.addDisabled = false
                })
              }).catch(() => {})
              this.TwoIsDisable = true
              setTimeout(() => {
                this.TwoIsDisable = false // 点击一次时隔两秒后才能再次点击
              }, 2000)
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        }
      },
      clearWeightingWeight() {
        if (this.xuanzhongArr == null) {
          DonMessage.error('请先选择一条数据')
        } else {
          if (this.xuanzhongArr.grossWeight) {
            clearSpecifiedWeightInfo({
                weightInfoId: this.xuanzhongArr.weightInfoId
              }).then(res => {
                this.getInWeightInfoList()
                this.addDisabled = false
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          } else {
            DonMessage.error('没有毛重数据')
          }
        }
      }
    },
    mounted() {}

  }

</script>

<style lang="less" scoped>
  .topForm {
    display: flex;
  }

  .weigthBox {
    width: 160px;
    height: 120px;
    border: dashed 3px green;
    text-align: center;
    line-height: 120px;
    font-size: 24px;
    font-weight: 700;
    color: red;
    background-color: #f6f6f6;
  }

  .weigthBoxB {
    width: 160px;
    height: 120px;
    border: dotted 3px #ccc;
    text-align: center;
    line-height: 120px;
    font-size: 24px;
    font-weight: 700;
    background-color: #f6f6f6;
  }

</style>
